import { Schema } from 'prosemirror-model';
import { v4 } from 'uuid';
import 'prosemirror-state';
import 'prosemirror-commands';
import 'prosemirror-inputrules';

var doc = {
    content: "block+"
};

var text = {
    group: "inline"
};

/**
 * 将父元素的textAlign 属性下移到子元素上
 * 主要场景为外部复制进来的数据源textAlign使用不规范，在node的getAttrs做清洗
 * @param el DOMNode
 * @return textAlign<String>
 */ var getAlign = function(el) {
    if (!el) return "";
    if (el.style && el.style.textAlign) {
        return el.style.textAlign;
    }
    return getAlign(el.parentNode);
};
/**
 * 计算 indent 值, 单级缩进值为 20
 * @param el DOMNode
 * @return number
 */ var getIndent = function(el) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var indent = 0;
    if (el && el.style && el.style.marginLeft) {
        // 只能返回整数
        indent = Math.round(parseInt(el.style.marginLeft, 10) / unit);
        // 计算出错就返回 0
        if (typeof indent !== "number" || Number.isNaN(indent) || indent < 0) {
            indent = 0;
        }
    }
    return indent;
};

var getParagraphAttrs = function(node) {
    var align = getAlign(node);
    var indent = getIndent(node);
    var dataDiffId = node.getAttribute("data-diff-id");
    var attrs = {
        id: v4(),
        indent: indent,
        // 过滤可能的 justify
        align: align === "justify" ? "left" : align,
        dataDiffId: dataDiffId || "ct-diff-id-".concat(v4())
    };
    return attrs;
};
var paragraph = {
    attrs: {
        indent: {
            default: 0
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    content: "inline*",
    group: "block",
    textContentBlock: true,
    alignBlock: true,
    parseDOM: [
        {
            tag: "p",
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return getParagraphAttrs(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, align = _node_attrs.align, indent = _node_attrs.indent, dataDiffId = _node_attrs.dataDiffId;
        var attrs = {};
        var style = "";
        if (align && align !== "left") {
            style += "text-align: ".concat(align, ";");
        }
        if (indent) {
            style += "margin-left: ".concat(Math.max(indent, 0) * 20, "px;");
        }
        if (style) {
            attrs.style = style;
        }
        attrs["data-diff-id"] = dataDiffId || "ct-diff-id-".concat(v4());
        return [
            "p",
            attrs,
            0
        ];
    }
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getHeadingAttrs = function(node, level) {
    var align = getAlign(node);
    var indent = getIndent(node);
    var dataDiffId = node.getAttribute("data-diff-id");
    var attrs = {
        id: v4(),
        indent: indent,
        // 过滤可能的 justify
        align: align === "justify" ? "left" : align,
        dataDiffId: dataDiffId || "ct-diff-id-".concat(v4())
    };
    return _objectSpread({
        level: level
    }, attrs);
};
var getHeading = function() {
    var levels = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        1,
        2,
        3,
        4,
        5,
        6
    ];
    var heading = {
        attrs: {
            id: {
                default: ""
            },
            level: {
                default: 1
            },
            indent: {
                default: 0
            },
            align: {
                default: "left"
            },
            dataDiffId: {
                default: null
            }
        },
        content: "inline*",
        textContentBlock: true,
        group: "block",
        defining: true,
        alignBlock: true,
        parseDOM: levels.map(function(level) {
            return {
                tag: "h".concat(level),
                preserveWhitespace: "full",
                getAttrs: function(dom) {
                    return getHeadingAttrs(dom, level);
                }
            };
        }),
        toDOM: function toDOM(node) {
            var _node_attrs = node.attrs, level = _node_attrs.level, align = _node_attrs.align, indent = _node_attrs.indent, id = _node_attrs.id, dataDiffId = _node_attrs.dataDiffId;
            var attrs = {};
            attrs.id = id || v4();
            var style = "";
            if (align && align !== "left") {
                style += "text-align: ".concat(align, ";");
            }
            if (indent) {
                style += "margin-left: ".concat(Math.max(indent, 0) * 20, "px;");
            }
            if (style) {
                attrs.style = style;
            }
            attrs.class = "ct-heading";
            attrs["data-diff-id"] = dataDiffId || "ct-diff-id-".concat(v4());
            return [
                "h".concat(level),
                attrs,
                0
            ];
        }
    };
    return heading;
};

var hard_break = {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [
        {
            tag: "br"
        }
    ],
    toDOM: function toDOM() {
        return [
            "br"
        ];
    }
};

var mention = {
    group: "inline",
    inline: true,
    // content: "inline*",
    // 修改原因: 将mention视为原子节点，里面不应该再包含其他任何节点。同时可以解决粘贴单个mention时，因为过滤了data-pm-slice属性之后而变成两个TextNode而不是mention Node #42274270
    atom: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 90,
    attrs: {
        name: {
            default: ""
        },
        uid: {
            default: ""
        },
        anchor: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'a[class*="ct-mention"]',
            getAttrs: function getAttrs(dom) {
                var nameDom = dom.querySelector("b");
                return {
                    name: nameDom ? nameDom.textContent : "",
                    uid: dom.getAttribute("data-uid"),
                    anchor: dom.getAttribute("data-anchor") || v4()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, name = _node_attrs.name, uid = _node_attrs.uid, anchor = _node_attrs.anchor;
        var attrs = {
            class: "ct-mention",
            "data-type": "ct-mention",
            "data-uid": uid,
            "data-anchor": anchor || v4()
        };
        return [
            "a",
            attrs,
            "@",
            [
                "b",
                name
            ]
        ];
    }
};

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var getListNodeAttrs = function(node) {
    var extraAttrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _node_attrs = node.attrs, indent = _node_attrs.indent, dataDiffId = _node_attrs.dataDiffId;
    var attrs = {
        "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
    };
    var style = "";
    if (indent) style += "margin-left: ".concat(indent * 20, "px;");
    if (style) attrs.style = style;
    return _objectSpread$1({}, attrs, extraAttrs);
};
var getItemNodeAttrs = function(node, extraAttrs) {
    var dataListItemDiffId = node.attrs.dataListItemDiffId;
    var attrs = {};
    attrs["data-list-item-diff-id"] = dataListItemDiffId || "ct-list-item-diff-id-".concat(v4());
    var firstChild = node.firstChild;
    if (firstChild && firstChild.type.name === "heading") {
        if (extraAttrs.class) {
            extraAttrs.class += " ct-item-level-".concat(firstChild.attrs.level);
        } else {
            attrs.class = "ct-item-level-".concat(firstChild.attrs.level);
        }
    }
    return _objectSpread$1({}, attrs, extraAttrs);
};

var task_list = {
    attrs: {
        indent: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    content: "(task_item | list_item)+",
    group: "block",
    defining: true,
    listRole: true,
    parseDOM: [
        {
            tag: 'ul[class="ct-task-list"]',
            getAttrs: function(dom) {
                var dataDiffId = dom.getAttribute("data-diff-id");
                var indent = getIndent(dom);
                return {
                    indent: indent,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getListNodeAttrs(node, {
            class: "ct-task-list"
        });
        return [
            "ul",
            attrs,
            0
        ];
    }
};

var task_item = {
    attrs: {
        checked: {
            default: false
        },
        level: {
            default: 0
        },
        dataListItemDiffId: {
            default: null
        }
    },
    content: "(paragraph | block)+",
    defining: true,
    parseDOM: [
        {
            tag: 'li[data-type="task_item"]',
            getAttrs: function getAttrs(dom) {
                var dataListItemDiffId = dom.getAttribute("data-list-item-diff-id");
                return {
                    checked: dom.classList.contains("ct-task-li-checked"),
                    dataListItemDiffId: dataListItemDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getItemNodeAttrs(node, {
            "data-type": "task_item",
            class: node.attrs.checked ? "ct-task-li-checked" : "ct-task-li"
        });
        return [
            "li",
            attrs,
            0
        ];
    }
};

var ordered_list = {
    attrs: {
        indent: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    content: "(list_item | task_item)+",
    group: "block",
    defining: true,
    listRole: true,
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function(dom) {
                var indent = getIndent(dom);
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    indent: indent,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getListNodeAttrs(node);
        return [
            "ol",
            attrs,
            0
        ];
    }
};

var bullet_list = {
    attrs: {
        indent: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    content: "(list_item | task_item)+",
    group: "block",
    defining: true,
    listRole: true,
    parseDOM: [
        {
            tag: 'ul:not([class="ct-task-list"])',
            getAttrs: function(dom) {
                var indent = getIndent(dom);
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    indent: indent,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getListNodeAttrs(node);
        return [
            "ul",
            attrs,
            0
        ];
    }
};

var list_item = {
    attrs: {
        level: {
            default: 0
        },
        hidden: {
            default: false
        },
        dataListItemDiffId: {
            default: null
        }
    },
    content: "(paragraph | block)+",
    defining: true,
    parseDOM: [
        {
            tag: 'li:not([data-type="task_item"])',
            getAttrs: function getAttrs(dom) {
                var dataListItemDiffId = dom.getAttribute("data-list-item-diff-id");
                var hidden = dom.classList.contains("ct-hidden-item");
                return {
                    hidden: hidden,
                    dataListItemDiffId: dataListItemDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getItemNodeAttrs(node, node.attrs.hidden ? {
            class: "ct-hidden-item"
        } : {});
        return [
            "li",
            attrs,
            0
        ];
    }
};

var link = {
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        href: {
            default: ""
        },
        title: {
            default: ""
        },
        autoUpdate: {
            default: ""
        }
    },
    group: "inline",
    content: "text*",
    defining: true,
    allowGapCursor: true,
    parseDOM: [
        {
            tag: "a[href]",
            getAttrs: function getAttrs(dom) {
                return {
                    id: v4(),
                    href: dom.getAttribute("href"),
                    title: dom.innerText,
                    autoUpdate: dom.getAttribute("data-auto_update") === "1"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, href = _node_attrs.href, autoUpdate = _node_attrs.autoUpdate;
        var attrs = {
            class: "ct-link",
            href: href,
            "data-auto_update": autoUpdate ? "1" : "0"
        };
        return [
            "a",
            attrs,
            0
        ];
    }
};

var time = {
    group: "inline",
    inline: true,
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 180,
    attrs: {
        isShowTime: {
            default: false
        },
        date: {
            default: ""
        },
        selectKey: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "time",
            getAttrs: function getAttrs(dom) {
                // 此处由原来的一个isShowTime变量（同时可以是string和boolean类型的值）更改为isShowTime和dataIsShowTime用于区分，
                var isShowTime;
                var dataIsShowTime = dom.getAttribute("data-isshowtime");
                if (dataIsShowTime === null) isShowTime = false;
                else if (dataIsShowTime === "true") isShowTime = true;
                else isShowTime = false;
                return {
                    date: dom.getAttribute("datetime"),
                    isShowTime: isShowTime,
                    selectKey: parseInt(dom.getAttribute("data-selectkey"), 10)
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, isShowTime = _node_attrs.isShowTime, date = _node_attrs.date, selectKey = _node_attrs.selectKey;
        var attrs = {
            class: "ct-time",
            datetime: "".concat(date),
            "data-isshowtime": "".concat(isShowTime),
            "data-selectkey": "".concat(selectKey)
        };
        return [
            "time",
            attrs,
            0
        ];
    }
};

var horizontal_rule = {
    group: "block",
    allowGapCursor: true,
    insertBlock: true,
    attrs: {
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "hr",
            getAttrs: function(dom) {
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(dom) {
        var dataDiffId = dom.attrs.dataDiffId;
        var attrs = {
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "hr",
            attrs
        ];
    }
};

var latex_inline = {
    group: "inline",
    content: "text*",
    inline: true,
    atom: true,
    allowGapCursor: true,
    braceWidth: 10,
    attrs: {
        content: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[class="ct-latex"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    dataDiffId: dom.getAttribute("data-diff-id"),
                    content: (dom.getAttribute("data-content") || dom.textContent || "").replace(/<br \/>/g, "\n")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-latex",
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "span",
            nodeAttrs,
            [
                "code",
                0
            ]
        ];
    }
};

var latex_block = {
    group: "block",
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 200,
    attrs: {
        content: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-latex"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    dataDiffId: dom.getAttribute("data-diff-id"),
                    content: (dom.getAttribute("data-content") || dom.textContent || "").replace(/<br \/>/g, "\n")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, source = _node_attrs.source, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-latex",
            "data-source": source,
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            nodeAttrs,
            [
                "pre",
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var image = {
    atom: true,
    group: "inline",
    inline: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        src: {
            default: ""
        },
        small: {
            default: ""
        },
        origin: {
            default: ""
        },
        mss: {
            default: ""
        },
        name: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        link: {
            default: null
        },
        border: {
            default: false
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-image"]',
            getAttrs: function getAttrs(dom) {
                var img = dom.querySelector("img");
                if (!img) {
                    return undefined;
                }
                var src = img.getAttribute("data-src");
                return {
                    src: src,
                    small: img.getAttribute("data-small") || src,
                    origin: img.getAttribute("data-origin") || src,
                    mss: img.getAttribute("data-mss") || "",
                    name: img.getAttribute("alt") || "",
                    width: parseInt(img.getAttribute("data-width"), 10) || 0,
                    height: parseInt(img.getAttribute("data-height"), 10) || 0,
                    link: img.getAttribute("data-link") || null,
                    border: dom.classList.contains("ct-image-border")
                };
            }
        },
        {
            tag: "img",
            getAttrs: function getAttrs(dom) {
                var src = dom.getAttribute("src");
                return {
                    name: dom.getAttribute("alt") || "",
                    origin: src,
                    small: src,
                    src: src,
                    width: dom.getAttribute("data-width") || dom.getAttribute("width") || 0,
                    height: dom.getAttribute("data-height") || dom.getAttribute("height") || 0
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, mss = _node_attrs.mss, name = _node_attrs.name, width = _node_attrs.width, height = _node_attrs.height, link = _node_attrs.link, border = _node_attrs.border;
        var _node_attrs1 = node.attrs, small = _node_attrs1.small, src = _node_attrs1.src, origin = _node_attrs1.origin;
        var attrs = {
            class: "ct-image".concat(border ? " ct-image-border" : "")
        };
        var imgAttrs = {
            alt: name.length > 100 ? "".concat(name.substr(0, 100), "...") : name,
            "data-origin": origin,
            "data-small": small,
            "data-src": src
        };
        if (width && width !== "0") {
            attrs.style = "width: ".concat(width, "px");
            imgAttrs["data-width"] = width;
            imgAttrs["data-height"] = height;
        }
        if (mss) {
            imgAttrs["data-mss"] = mss;
        }
        if (link) {
            imgAttrs["data-link"] = link;
        }
        return [
            "span",
            attrs,
            [
                "img",
                imgAttrs
            ]
        ];
    }
};

var colors = [
    "#ccc",
    "#f5222d",
    "#fadb14",
    "#52c41a",
    "#1890ff"
];
var colorsMap = {
    gray: "#ccc",
    red: "#f5222d",
    yellow: "#fadb14",
    green: "#52c41a",
    blue: "#1890ff"
};

var formatOldValue = function(color) {
    if (colorsMap[color]) {
        return colorsMap[color];
    }
    return color || "";
};
var status = {
    group: "inline",
    content: "text*",
    inline: true,
    defining: true,
    allowGapCursor: true,
    braceWidth: 90,
    attrs: {
        pattern: {
            default: "fill"
        },
        color: {
            default: "#ccc"
        },
        expand: {
            default: false
        },
        input: {
            default: false
        },
        selectedkey: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-status"]',
            getAttrs: function(dom) {
                var color = formatOldValue(dom.getAttribute("data-color"));
                return {
                    color: color,
                    pattern: dom.getAttribute("data-pattern"),
                    expand: !colors.includes(color)
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, pattern = _node_attrs.pattern, color = _node_attrs.color;
        var nodeAttrs = {
            class: "ct-status",
            "data-pattern": pattern,
            "data-color": color
        };
        return [
            "span",
            nodeAttrs,
            0
        ];
    }
};

var audio = {
    group: "block",
    atom: true,
    draggable: true,
    dragBlock: true,
    insertBlock: true,
    alignBlock: true,
    allowGapCursor: true,
    braceWidth: 540,
    attrs: {
        url: {
            default: ""
        },
        size: {
            default: ""
        },
        name: {
            default: ""
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-audio"]',
            getAttrs: function getAttrs(dom) {
                var align = "left";
                if (dom.className.includes("center")) {
                    align = "center";
                } else if (dom.className.includes("right")) {
                    align = "right";
                }
                return {
                    url: dom.getAttribute("data-url"),
                    name: dom.getAttribute("data-name"),
                    size: dom.getAttribute("data-size"),
                    align: align,
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, url = _node_attrs.url, name = _node_attrs.name, size = _node_attrs.size, align = _node_attrs.align, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-audio",
            "data-url": url,
            "data-name": name,
            "data-size": size,
            contenteditable: "false",
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        if (align === "center") {
            nodeAttrs.class += " align-center";
        } else if (align === "right") {
            nodeAttrs.class += " align-right";
        }
        var audioAttrs = {
            controls: "false",
            preload: "meta"
        };
        return [
            "div",
            nodeAttrs,
            [
                "audio",
                audioAttrs,
                "本浏览器不支持 HTML5 audio 标签"
            ]
        ];
    }
};

var video = {
    group: "block",
    atom: true,
    draggable: true,
    dragBlock: true,
    insertBlock: true,
    alignBlock: true,
    allowGapCursor: true,
    braceWidth: 540,
    attrs: {
        url: {
            default: ""
        },
        size: {
            default: ""
        },
        name: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-video"]',
            getAttrs: function getAttrs(dom) {
                var align = "left";
                if (dom.className.includes("center")) {
                    align = "center";
                } else if (dom.className.includes("right")) {
                    align = "right";
                }
                return {
                    url: dom.getAttribute("data-url"),
                    name: dom.getAttribute("data-name"),
                    size: dom.getAttribute("data-size"),
                    width: dom.getAttribute("data-width") || 0,
                    height: dom.getAttribute("data-height") || 0,
                    align: align,
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, url = _node_attrs.url, name = _node_attrs.name, size = _node_attrs.size, width = _node_attrs.width, height = _node_attrs.height, align = _node_attrs.align, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-video",
            "data-url": url,
            "data-name": name,
            "data-size": size,
            "data-width": width,
            "data-height": height,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        if (align === "center") {
            nodeAttrs.class += " align-center";
        } else if (align === "right") {
            nodeAttrs.class += " align-right";
        }
        var videoAttrs = {
            controls: "false",
            preload: "meta"
        };
        return [
            "div",
            nodeAttrs,
            [
                "video",
                videoAttrs,
                "本浏览器不支持 HTML5 video 标签"
            ]
        ];
    }
};

var formatSize = function(size) {
    if (!size) {
        size = "0KB";
    }
    var count = -1;
    for(var i = size.length - 1; i >= 0; i--){
        if (size[i].toUpperCase() !== "B") break;
        count += 1;
    }
    return size.slice(0, size.length - count);
};
var attachment = {
    group: "block",
    atom: true,
    draggable: true,
    insertBlock: true,
    alignBlock: true,
    allowGapCursor: true,
    braceWidth: 340,
    attrs: {
        src: {
            default: ""
        },
        size: {
            default: ""
        },
        name: {
            default: ""
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'a[class~="ct-attachment"]',
            getAttrs: function getAttrs(dom) {
                var align = "left";
                if (dom.className.includes("center")) {
                    align = "center";
                } else if (dom.className.includes("right")) {
                    align = "right";
                }
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    src: dom.getAttribute("data-src"),
                    size: dom.querySelector(".size").innerText,
                    name: dom.querySelector(".name").innerText,
                    align: align,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, name = _node_attrs.name, size = _node_attrs.size, src = _node_attrs.src, align = _node_attrs.align, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-attachment",
            spellcheck: "false",
            "data-src": src,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        if (align === "center") {
            nodeAttrs.class += " align-center";
        } else if (align === "right") {
            nodeAttrs.class += " align-right";
        }
        return [
            "a",
            nodeAttrs,
            [
                "div",
                {
                    class: "large-icon"
                }
            ],
            [
                "div",
                {
                    class: "right"
                },
                [
                    "div",
                    {
                        class: "name",
                        title: name
                    },
                    name
                ],
                [
                    "div",
                    {
                        class: "size"
                    },
                    formatSize(size)
                ],
                [
                    "div",
                    {
                        class: "copy"
                    },
                    [
                        "div",
                        {
                            class: "btn-copy"
                        }
                    ]
                ],
                [
                    "div",
                    {
                        class: "download"
                    },
                    [
                        "div",
                        {
                            class: "btn-download"
                        }
                    ]
                ]
            ]
        ];
    }
};

var DEFAULT_LANGUAGE = "Plain Text";
var DEFAULT_THEME = "xq-light";
var DEFAULT_TITLE = "代码块";
var code_block = {
    group: "block",
    content: "text*",
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    marks: "",
    attrs: {
        language: {
            default: DEFAULT_LANGUAGE
        },
        theme: {
            default: DEFAULT_THEME
        },
        title: {
            default: DEFAULT_TITLE
        },
        isExpand: {
            default: true
        },
        isCreate: {
            default: false
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-code"]',
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                var titleDOM = dom.querySelector(".title");
                var languageDOM = dom.querySelector(".language");
                var dataDiffId = dom.getAttribute("data-diff-id");
                var _dom_dataset = dom.dataset, _dom_dataset_language = _dom_dataset.language, language = _dom_dataset_language === void 0 ? languageDOM ? languageDOM.getAttribute("data-language") || DEFAULT_LANGUAGE : DEFAULT_LANGUAGE : _dom_dataset_language, _dom_dataset_theme = _dom_dataset.theme, theme = _dom_dataset_theme === void 0 ? DEFAULT_THEME : _dom_dataset_theme, _dom_dataset_title = _dom_dataset.title, title = _dom_dataset_title === void 0 ? titleDOM ? titleDOM.getAttribute("data-title") || DEFAULT_TITLE : DEFAULT_TITLE : _dom_dataset_title;
                var isExpand;
                if (dom.querySelector(".isNotExpand")) {
                    isExpand = false;
                } else {
                    isExpand = dom.getAttribute("data-expand") !== "false";
                }
                return {
                    language: language,
                    theme: theme,
                    title: title,
                    isExpand: isExpand,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, language = _node_attrs.language, theme = _node_attrs.theme, title = _node_attrs.title, isExpand = _node_attrs.isExpand, dataDiffId = _node_attrs.dataDiffId;
        var attrs = {
            class: "ct-code",
            spellcheck: "false",
            "data-language": language,
            "data-theme": theme,
            "data-title": title,
            "data-expand": isExpand,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            attrs,
            [
                "pre",
                {},
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var catalog = {
    group: "block",
    atom: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 420,
    attrs: {
        style: {
            default: "none"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-edit-catalog"]',
            getAttrs: function(dom) {
                if (typeof dom === "object" && dom.getAttribute("data-style")) {
                    var dataDiffId = dom.getAttribute("data-diff-id");
                    return {
                        style: dom.getAttribute("data-style"),
                        dataDiffId: dataDiffId
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, style = _node_attrs.style, dataDiffId = _node_attrs.dataDiffId;
        var catalogAttrs = {
            class: "ct-edit-catalog",
            "data-style": style,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            catalogAttrs,
            "目录"
        ];
    }
};

var note = {
    group: "block",
    content: "note_title note_content",
    isolating: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 300,
    attrs: {
        type: {
            default: "note"
        },
        hiddenTitle: {
            default: true
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-note"]',
            getAttrs: function(dom) {
                return {
                    type: dom.getAttribute("data-type"),
                    hiddenTitle: dom.classList.contains("hidden-title"),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, type = _node_attrs.type, hiddenTitle = _node_attrs.hiddenTitle, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-note".concat(hiddenTitle ? " hidden-title" : ""),
            "data-type": type,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var note_title = {
    content: "text*",
    alignBlock: true,
    attrs: {
        align: {
            default: "left"
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-note-title"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    align: dom.style.textAlign
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var align = node.attrs.align;
        var attrs = {
            class: "ct-note-title"
        };
        if (align && align !== "left") {
            attrs.style = "text-align: ".concat(align, ";");
        }
        return [
            "div",
            attrs,
            [
                "span",
                {
                    class: "ct-note-title-text"
                },
                0
            ]
        ];
    }
};

var note_content = {
    content: "block+",
    attrs: {},
    parseDOM: [
        {
            tag: 'div[class~="ct-note-content"]'
        }
    ],
    toDOM: function toDOM() {
        var nodeAttrs = {
            class: "ct-note-content"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var blockquote = {
    content: "block+",
    group: "block",
    defining: true,
    allowGapCursor: true,
    attrs: {
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "blockquote",
            getAttrs: function getAttrs(dom) {
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(dom) {
        var dataDiffId = dom.attrs.dataDiffId;
        return [
            "blockquote",
            {
                class: "ct-blockquote",
                "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
            },
            0
        ];
    }
};

var spaceupdate = {
    group: "block",
    content: "text*",
    atom: true,
    insertBlock: true,
    dragBlock: true,
    draggable: true,
    braceWidth: 200,
    attrs: {
        spaceId: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-space-update"]',
            getAttrs: function(dom) {
                return {
                    spaceId: dom.getAttribute("data-space-id") || ""
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var spaceId = node.attrs.spaceId;
        var nodeAttrs = {
            class: "ct-space-update",
            "data-space-id": spaceId,
            contenteditable: "false"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

// 默认不限深度
var DEFAULT_MAX_DEPTH = 0;
var page_tree = {
    group: "block",
    content: "text*",
    atom: true,
    insertBlock: true,
    dragBlock: true,
    draggable: true,
    braceWidth: 200,
    attrs: {
        spaceId: {
            default: ""
        },
        pageId: {
            default: ""
        },
        maxDepth: {
            default: DEFAULT_MAX_DEPTH
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-page-tree"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    spaceId: dom.getAttribute("data-space-id") || "",
                    pageId: dom.getAttribute("data-page-id") || "",
                    maxDepth: dom.getAttribute("data-max-depth") || DEFAULT_MAX_DEPTH
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, spaceId = _node_attrs.spaceId, pageId = _node_attrs.pageId, maxDepth = _node_attrs.maxDepth;
        var nodeAttrs = {
            class: "ct-page-tree",
            "data-space-id": spaceId,
            "data-page-id": pageId,
            "data-max-depth": maxDepth,
            contenteditable: "false"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var table = {
    content: "table_row+",
    tableRole: "table",
    isolating: true,
    allowGapCursor: true,
    insertBlock: true,
    group: "block",
    attrs: {
        indent: {
            default: 0
        },
        responsive: {
            default: false
        },
        borderStyle: {
            default: "solid"
        },
        borderWidth: {
            default: 1
        },
        borderColor: {
            default: "#dddddd"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "table",
            getAttrs: function getAttrs(dom) {
                var borderWidth = parseInt(dom.getAttribute("data-borderwidth"), 10);
                return {
                    indent: getIndent(dom),
                    responsive: dom.classList.contains("responsive"),
                    borderStyle: dom.getAttribute("data-borderstyle") || "solid",
                    borderWidth: Number.isNaN(borderWidth) ? 1 : borderWidth,
                    borderColor: dom.getAttribute("data-bordercolor") || "#dddddd",
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, indent = _node_attrs.indent, responsive = _node_attrs.responsive, borderStyle = _node_attrs.borderStyle, borderWidth = _node_attrs.borderWidth, borderColor = _node_attrs.borderColor, dataDiffId = _node_attrs.dataDiffId;
        var attrs = {};
        if (indent > 0) attrs.style = "margin-left: ".concat(indent * 20, "px;");
        if (responsive) attrs.class = "responsive";
        // TODO: 需要云皓之后有空补充说明一下当时加这三个if条件判断的原因
        if (borderStyle !== "solid") attrs["data-borderstyle"] = borderStyle;
        if (borderWidth !== "1") attrs["data-borderwidth"] = borderWidth;
        if (borderColor !== "#dddddd") attrs["data-bordercolor"] = borderColor;
        attrs["data-diff-id"] = dataDiffId || "ct-diff-id-".concat(v4());
        return [
            "table",
            attrs,
            [
                "tbody",
                0
            ]
        ];
    }
};

var table_row = {
    content: "(table_cell | table_header)*",
    tableRole: "row",
    attrs: {
        dataRowDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "tr",
            getAttrs: function getAttrs(dom) {
                var dataRowDiffId = dom.getAttribute("data-row-diff-id");
                return {
                    dataRowDiffId: dataRowDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var dataRowDiffId = node.attrs.dataRowDiffId;
        var attrs = {
            "data-row-diff-id": dataRowDiffId || "ct-tr-diff-id-".concat(v4())
        };
        return [
            "tr",
            attrs,
            0
        ];
    }
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_COL_WIDTH = 68;
var MIN_COL_WIDTH = 50;
var cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: [
            DEFAULT_COL_WIDTH
        ]
    },
    textAlign: {
        default: null
    },
    verticalAlign: {
        default: null
    },
    bgColor: {
        default: null
    },
    color: {
        default: null
    },
    numCell: {
        default: null
    },
    dataCellDiffId: {
        default: null
    }
};
// dpi=1.25时，表格宽度需要为 4 的整数倍
var formatWidth = function(width) {
    // width = Math.round(width);
    // width = Math.round(width / 4) * 4;
    return width;
};
var getWidthNumber = function(width, tableWidth) {
    if (typeof width === "string") {
        // 兼容百分比宽度
        if (width.includes("%")) {
            return parseFloat(width) * 0.01 * tableWidth;
        }
        return parseInt(width, 10);
    }
    return width;
};
var checkBraceWidthChild = function(node) {
    var textBlockNames = [
        "paragraph",
        "heading"
    ];
    var hasBraceWidthChild = false;
    node.content.forEach(function(child) {
        if (child.type.spec.braceWidth) {
            hasBraceWidthChild = true;
        } else if (textBlockNames.includes(child.type.name)) {
            child.content.forEach(function(inlineChild) {
                if (inlineChild.type.spec.braceWidth) {
                    hasBraceWidthChild = true;
                }
            });
        }
    });
    return hasBraceWidthChild;
};
function getCellAttrs(dom) {
    var pmDOM = document.querySelector(".ProseMirror");
    var widthAttr = dom.getAttribute("data-colwidth");
    var tableWidth = pmDOM ? pmDOM.clientWidth : 0;
    var tableEl = dom.parentNode.parentNode.parentNode;
    var colgroupEl = tableEl.children[0];
    var index = Array.from(dom.parentNode.children).findIndex(function(el) {
        return el === dom;
    });
    var col = colgroupEl.children[index];
    var colspan = parseFloat(dom.getAttribute("colspan")) || 1;
    var rowspan = parseFloat(dom.getAttribute("rowspan")) || 1;
    if (!widthAttr) {
        widthAttr = dom.width || dom.style.width || col && (col.width || col.style.width);
        tableWidth = getWidthNumber(tableEl.style.width, tableWidth);
    }
    var widths;
    /**
   * 很早以前的数据可能出现 widthAttr 的数量大于 colspan，
   * 后来修改逻辑之后 widthAttr 的数量一定等于 colspan。
   * 为了避免异常对于这样的数据，将所有 width 求和成一个 col 的 width，其余的 col 填充最小宽度
   */ if (widthAttr && widthAttr.split(",").length > colspan) {
        widths = [
            widthAttr.split(",").map(function(p) {
                return parseInt(p, 10);
            }).reduce(function(prev, cur) {
                return prev + cur;
            })
        ];
    } else {
        // 如果没有 widthAttr 则将第一个 col 设为表格总宽度除以列数，其余的 col 填充最小宽度
        widths = widthAttr ? widthAttr.split(",").map(function(w) {
            return getWidthNumber(w, tableWidth);
        }) : [
            tableWidth / (colgroupEl.children[0] ? colgroupEl.children[0].children.length : 1)
        ];
        widths = widths.map(function(num) {
            return num < MIN_COL_WIDTH ? MIN_COL_WIDTH : ~~num;
        });
    }
    var widthsLen = widths.length;
    if (widthsLen < colspan) {
        var fillArr = new Array(colspan - widthsLen);
        fillArr.fill(MIN_COL_WIDTH);
        widths = _toConsumableArray(widths).concat(_toConsumableArray(fillArr));
    }
    if (window.devicePixelRatio === 1.25) {
        widths = widths.map(formatWidth);
    }
    var dataCellDiffId = dom.getAttribute("data-cell-diff-id");
    var result = {
        dataCellDiffId: dataCellDiffId,
        colspan: colspan,
        rowspan: rowspan,
        colwidth: widthsLen <= colspan ? widths : [
            MIN_COL_WIDTH
        ],
        bgColor: dom.style.backgroundColor,
        // table_cell 上不应该存在textAlign属性。避免改schema，姑且在这里设空
        // 相关ones #6816509 #64513785
        textAlign: "",
        verticalAlign: dom.style.verticalAlign,
        color: dom.style.color,
        numCell: dom.classList.contains("num-cell")
    };
    return result;
}
function setCellAttrs(node) {
    var attrs = {};
    var nodeAttrs = node.attrs;
    // 未知原因 span 的值可能出现负数，此时使用默认值 1
    nodeAttrs.colspan = Math.max(nodeAttrs.colspan, 1);
    nodeAttrs.rowspan = Math.max(nodeAttrs.rowspan, 1);
    if (nodeAttrs.colspan !== 1) {
        attrs.colspan = nodeAttrs.colspan;
    }
    if (nodeAttrs.rowspan !== 1) {
        attrs.rowspan = nodeAttrs.rowspan;
    }
    if (nodeAttrs.colwidth) {
        attrs["data-colwidth"] = nodeAttrs.colwidth.join(",");
    } else {
        attrs["data-colwidth"] = "".concat(DEFAULT_COL_WIDTH);
    }
    attrs.width = attrs["data-colwidth"];
    // 检查单元格内是否有会溢出内容
    if (checkBraceWidthChild(node)) attrs.class = "overflow";
    var style = "";
    if (nodeAttrs.bgColor) style += "background-color: ".concat(nodeAttrs.bgColor, ";");
    if (nodeAttrs.color) style += "color: ".concat(nodeAttrs.color, ";");
    if (nodeAttrs.verticalAlign) {
        style += "vertical-align:".concat(nodeAttrs.verticalAlign, ";");
    }
    if (style) attrs.style = style;
    if (nodeAttrs.numCell) {
        attrs.contenteditable = true;
        attrs.style = "caret-color: transparent";
        attrs.class = attrs.class ? "".concat(attrs.class, " num-cell") : "num-cell";
    }
    attrs["data-cell-diff-id"] = nodeAttrs.dataCellDiffId || "ct-cell-diff-id-".concat(v4());
    return attrs;
}

var table_cell = {
    content: "block+",
    attrs: cellAttrs,
    tableRole: "cell",
    isolating: true,
    parseDOM: [
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return getCellAttrs(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            setCellAttrs(node),
            0
        ];
    }
};

var table_header = {
    content: "block+",
    attrs: cellAttrs,
    tableRole: "header_cell",
    isolating: true,
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return getCellAttrs(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            setCellAttrs(node),
            0
        ];
    }
};

var markdown = {
    group: "block",
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 200,
    attrs: {
        content: {
            default: ""
        },
        source: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-markdown"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    source: dom.getAttribute("data-source") || "",
                    content: (dom.getAttribute("data-content") || dom.textContent || "").replace(/<br \/>/g, "\n"),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, source = _node_attrs.source, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-markdown",
            "data-source": source,
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            nodeAttrs,
            [
                "pre",
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var html = {
    group: "block",
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 200,
    attrs: {
        content: {
            default: ""
        },
        source: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-html"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    source: dom.getAttribute("data-source") || "",
                    content: dom.getAttribute("data-content") || dom.textContent || "",
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, source = _node_attrs.source, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-html",
            "data-source": source,
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            nodeAttrs,
            [
                "pre",
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var gantt = {
    group: "block",
    content: "inline*",
    atom: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    attrs: {
        id: {
            default: ""
        },
        height: {
            default: "0"
        },
        version: {
            default: "0"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-gantt"]',
            getAttrs: function(dom) {
                return {
                    id: dom.getAttribute("data-id"),
                    height: parseInt(dom.getAttribute("data-height"), 10),
                    version: parseInt(dom.getAttribute("data-version"), 10),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, id = _node_attrs.id, height = _node_attrs.height, version = _node_attrs.version, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-gantt",
            "data-id": "".concat(id),
            "data-height": "".concat(height),
            "data-version": "".concat(version),
            style: "{height: ".concat(height, "px}"),
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            nodeAttrs
        ];
    }
};

var data2chart = {
    group: "inline",
    inline: true,
    atom: true,
    allowGapCursor: true,
    dragBlock: true,
    attrs: {
        id: {
            default: ""
        },
        config: {
            default: ""
        },
        chartData: {
            default: ""
        },
        pageId: {
            default: ""
        },
        chartId: {
            default: ""
        },
        height: {
            default: 400
        },
        width: {
            default: 600
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-data2chart"]',
            getAttrs: function(dom) {
                return {
                    id: dom.getAttribute("data-data2chart-id"),
                    pageId: dom.getAttribute("data-data2chart-page-id"),
                    config: dom.getAttribute("data-config"),
                    chartData: dom.getAttribute("data-chartData"),
                    chartId: dom.getAttribute("data-data2chart-chartId"),
                    height: dom.getAttribute("data-height"),
                    width: dom.getAttribute("data-width")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, id = _node_attrs.id, pageId = _node_attrs.pageId, chartId = _node_attrs.chartId, height = _node_attrs.height, width = _node_attrs.width;
        var nodeAttrs = {
            class: "ct-data2chart",
            "data-data2chart-id": "".concat(id),
            "data-data2chart-page-id": "".concat(pageId),
            "data-data2chart-chartId": chartId ? "".concat(chartId) : "",
            "data-height": height,
            "data-width": width
        };
        return [
            "span",
            nodeAttrs
        ];
    }
};

var calendar = {
    group: "block",
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 900,
    draggable: false,
    selectable: false,
    atom: true,
    attrs: {
        id: {
            default: 0
        },
        view: {
            default: "month"
        },
        docId: {
            default: 0
        },
        paste: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-calendar"]',
            getAttrs: function(dom) {
                return {
                    id: parseInt(dom.getAttribute("data-id"), 10),
                    docId: parseInt(dom.getAttribute("data-doc-id"), 10),
                    paste: parseInt(dom.getAttribute("data-paste"), 10),
                    view: dom.getAttribute("data-view"),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function(node) {
        var _node_attrs = node.attrs, id = _node_attrs.id, docId = _node_attrs.docId, paste = _node_attrs.paste, view = _node_attrs.view, dataDiffId = _node_attrs.dataDiffId;
        var v = view;
        if (view !== "month" && view !== "week") {
            v = "month";
        }
        var attrs = {
            class: "ct-calendar",
            "data-id": "".concat(id),
            "data-view": "".concat(v),
            "data-doc-id": "".concat(docId),
            "data-paste": "".concat(paste),
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            attrs
        ];
    }
};

var plantuml = {
    atom: true,
    group: "inline",
    inline: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        content: {
            default: ""
        },
        width: {
            default: 64
        },
        height: {
            default: 64
        },
        border: {
            default: false
        },
        resize: {
            default: true
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-plantuml"]',
            getAttrs: function getAttrs(dom) {
                return {
                    content: decodeURI(dom.getAttribute("data-content") || ""),
                    width: parseInt(dom.getAttribute("data-width") || "0", 10),
                    height: parseInt(dom.getAttribute("data-height") || "0", 10),
                    border: dom.getAttribute("data-border") || false,
                    resize: true
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, width = _node_attrs.width, content = _node_attrs.content, border = _node_attrs.border, height = _node_attrs.height;
        var attrs = {
            class: "ct-plantuml",
            "data-content": encodeURI(content),
            "data-width": "".concat(width),
            "data-height": "".concat(height),
            "data-border": "".concat(border ? 1 : "")
        };
        return [
            "span",
            attrs
        ];
    }
};

var drawio = {
    group: "inline",
    inline: true,
    atom: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        src: {
            default: ""
        },
        xml: {
            default: ""
        },
        mss: {
            default: ""
        },
        mssXml: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        border: {
            default: true
        },
        hadResize: {
            default: false
        }
    },
    parseDOM: [
        {
            priority: 60,
            tag: 'span[class~="ct-drawio"]',
            getAttrs: function getAttrs(dom) {
                var img = dom.querySelector("img") || dom;
                return {
                    src: img.getAttribute("data-src"),
                    "data-src": img.getAttribute("data-src"),
                    mss: img.getAttribute("data-mss") || "",
                    xml: img.getAttribute("data-xml"),
                    mssXml: img.getAttribute("data-mssxml") || "",
                    width: img.getAttribute("data-width") || 0,
                    height: img.getAttribute("data-height") || 0,
                    border: dom.classList.contains("ct-image-border"),
                    hadResize: dom.getAttribute("data-hadresize")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, src = _node_attrs.src, xml = _node_attrs.xml, mss = _node_attrs.mss, mssXml = _node_attrs.mssXml, width = _node_attrs.width, height = _node_attrs.height, border = _node_attrs.border, hadResize = _node_attrs.hadResize;
        var attrs = {
            class: "ct-drawio".concat(border ? " ct-image-border" : ""),
            style: ""
        };
        var imgAttrs = {
            alt: "draw.io",
            "data-src": src,
            "data-type": "drawio"
        };
        if (xml) {
            imgAttrs["data-xml"] = xml;
        }
        if (width) {
            attrs.style = "width: ".concat(width, "px");
            imgAttrs["data-width"] = width;
            imgAttrs["data-height"] = height;
        }
        if (mss) {
            imgAttrs["data-mss"] = mss;
            if (mssXml) {
                imgAttrs["data-mssxml"] = mssXml;
            }
        }
        if (hadResize) {
            attrs["data-hadresize"] = hadResize;
        }
        return [
            "span",
            attrs,
            [
                "img",
                imgAttrs
            ]
        ];
    }
};

var minder = {
    atom: true,
    draggable: true,
    group: "inline",
    inline: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        src: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        border: {
            default: true
        },
        hadResize: {
            default: false
        }
    },
    parseDOM: [
        {
            priority: 60,
            tag: 'span[class~="ct-minder"]',
            getAttrs: function getAttrs(dom) {
                var img = dom.querySelector("img") || dom;
                return {
                    src: img.getAttribute("data-src"),
                    "data-src": img.getAttribute("data-src"),
                    width: img.getAttribute("data-width") || 0,
                    height: img.getAttribute("data-height") || 0,
                    border: dom.classList.contains("ct-image-border"),
                    hadResize: dom.getAttribute("data-hadresize")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, src = _node_attrs.src, width = _node_attrs.width, height = _node_attrs.height, border = _node_attrs.border, hadResize = _node_attrs.hadResize;
        var attrs = {
            class: "ct-minder".concat(border ? " ct-image-border" : ""),
            style: ""
        };
        var imgAttrs = {
            alt: "minder",
            "data-src": src,
            "data-type": "minder"
        };
        if (width || height) {
            attrs.style = "width: ".concat(width, "px; height: ").concat(height, "px");
            imgAttrs["data-width"] = width;
            imgAttrs["data-height"] = height;
        }
        if (hadResize) {
            attrs["data-hadresize"] = hadResize;
        }
        return [
            "span",
            attrs,
            [
                "img",
                imgAttrs
            ]
        ];
    }
};

var collapse = {
    group: "block",
    content: "collapse_title collapse_content",
    isolating: true,
    allowGapCursor: true,
    dragBlock: true,
    insertBlock: true,
    braceWidth: 300,
    attrs: {
        active: {
            default: true
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "div[class~='ct-collapse']",
            getAttrs: function getAttrs(dom) {
                var ele = dom;
                var dataDiffId = ele.getAttribute("data-diff-id");
                return {
                    active: ele.classList.contains("active"),
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, active = _node_attrs.active, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-collapse".concat(active ? " active" : ""),
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(v4())
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};
var collapse_title = {
    content: "text*",
    draggable: false,
    isolating: true,
    alignBlock: true,
    attrs: {
        align: {
            default: "left"
        }
    },
    parseDOM: [
        {
            tag: "div[class~='ct-collapse-title']",
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    align: dom.style.textAlign
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var align = node.attrs.align;
        var attrs = {
            class: "ct-collapse-title"
        };
        if (align && align !== "left") {
            attrs.style = "text-align: ".concat(align, ";");
        }
        return [
            "div",
            attrs,
            [
                "span",
                {
                    class: "ct-collapse-title-text",
                    spellCheck: false
                },
                0
            ]
        ];
    }
};
var collapse_content = {
    content: "block+",
    isolating: true,
    attrs: {},
    parseDOM: [
        {
            tag: "div[class~='ct-collapse-content']"
        }
    ],
    toDOM: function toDOM() {
        var nodeAttrs = {
            class: "ct-collapse-content"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var em = {
    parseDOM: [
        {
            tag: "i"
        },
        {
            tag: "em"
        },
        {
            style: "font-style=italic"
        }
    ],
    toDOM: function() {
        return [
            "em"
        ];
    }
};

var strikethrough = {
    parseDOM: [
        {
            tag: "del"
        },
        {
            style: "text-decoration=line-through"
        }
    ],
    toDOM: function toDOM() {
        return [
            "del"
        ];
    }
};

var strong = {
    parseDOM: [
        {
            tag: "strong"
        },
        {
            tag: "b",
            getAttrs: function(dom) {
                return dom.style.fontWeight !== "normal" && null;
            }
        },
        {
            style: "font-weight",
            getAttrs: function(value) {
                return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "strong"
        ];
    }
};

var underline = {
    parseDOM: [
        {
            tag: "u"
        },
        {
            style: "text-decoration=underline"
        }
    ],
    toDOM: function toDOM() {
        return [
            "u"
        ];
    }
};

var font = {
    attrs: {
        dataSize: {
            default: 14
        }
    },
    parseDOM: [
        {
            tag: "font",
            getAttrs: function(dom) {
                var size = parseInt(dom.getAttribute("data-size"), 10) || 14;
                return {
                    dataSize: size
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var lineHeight = node.attrs.dataSize + 8;
        var style = {
            style: "font-size:".concat(node.attrs.dataSize, "px;line-height:").concat(lineHeight, "px"),
            "data-size": node.attrs.dataSize
        };
        return [
            "font",
            style
        ];
    }
};

var color = {
    attrs: {
        color: {
            default: "#333"
        }
    },
    parseDOM: [
        {
            priority: 20,
            tag: "span[style*=color]",
            getAttrs: function(node) {
                return {
                    color: node.style.color
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                style: "color: ".concat(node.attrs.color)
            }
        ];
    }
};

var sub = {
    parseDOM: [
        {
            tag: "sub"
        }
    ],
    toDOM: function toDOM() {
        return [
            "sub"
        ];
    }
};

var sup = {
    parseDOM: [
        {
            tag: "sup"
        }
    ],
    toDOM: function toDOM() {
        return [
            "sup"
        ];
    }
};

var citadelSchemaSpec = {
    nodes: {
        doc: doc,
        text: text,
        paragraph: paragraph,
        heading: getHeading(),
        hard_break: hard_break,
        mention: mention,
        task_list: task_list,
        task_item: task_item,
        ordered_list: ordered_list,
        bullet_list: bullet_list,
        list_item: list_item,
        link: link,
        horizontal_rule: horizontal_rule,
        latex_inline: latex_inline,
        latex_block: latex_block,
        status: status,
        image: image,
        audio: audio,
        video: video,
        attachment: attachment,
        code_block: code_block,
        collapse: collapse,
        collapse_title: collapse_title,
        collapse_content: collapse_content,
        time: time,
        catalog: catalog,
        note: note,
        note_title: note_title,
        note_content: note_content,
        blockquote: blockquote,
        spaceupdate: spaceupdate,
        page_tree: page_tree,
        table: table,
        table_row: table_row,
        table_cell: table_cell,
        table_header: table_header,
        markdown: markdown,
        html: html,
        gantt: gantt,
        data2chart: data2chart,
        calendar: calendar,
        plantuml: plantuml,
        drawio: drawio,
        minder: minder
    },
    marks: {
        em: em,
        strong: strong,
        underline: underline,
        strikethrough: strikethrough,
        color: color,
        sub: sub,
        sup: sup,
        font: font
    }
};
var index = new Schema(citadelSchemaSpec);

export default index;
export { citadelSchemaSpec, getHeading };
//# sourceMappingURL=index.js.map
